/** Найти зарегистрированный элемент с хуком openSuggester (как refillElementViaControls). */
export function resolveOpenSuggesterRegistryEntry(
  elements: Record<string, unknown>,
  elementName: string,
  formId?: string,
): { openSuggester?: () => void } | undefined {
  const name = String(elementName ?? '').trim()
  if (!name) return undefined

  const fid = String(formId ?? '').trim()
  const hasHook = (el: unknown): el is { openSuggester: () => void; formId?: unknown; fieldName?: unknown; name?: unknown } =>
    !!el &&
    typeof el === 'object' &&
    typeof (el as { openSuggester?: unknown }).openSuggester === 'function'

  const matchesForm = (el: { formId?: unknown }) => {
    if (!fid) return true
    const regFid = String(el.formId ?? '').trim()
    return !regFid || regFid === fid
  }

  // Ключ реестра = fieldName (en.getElement("placeType")); formId на элементе может быть slot, а не registry id.
  const direct = elements[name]
  if (hasHook(direct)) {
    return direct
  }

  for (const [key, raw] of Object.entries(elements)) {
    if (!hasHook(raw)) continue
    const el = raw
    const fieldName = String(el.fieldName ?? el.name ?? key).trim()
    if (fieldName !== name && key !== name) continue
    if (!matchesForm(el)) continue
    return el
  }

  return undefined
}
